/* eslint-disable ember/no-computed-properties-in-native-classes, getter-return */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import moment from 'moment';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';
import { findBy, uniqBy } from '@linc-technologies/linced-common/utils/arrays';

export default class DailyAbsencesController extends Controller {
  @action
  setNewDate(value) {
    this.newDate = value;
  }

  @service
  dates;

  @tracked reportDate = moment().format('YYYY-MM-DD');
  @tracked newDate = moment().format('YYYY-MM-DD');

  get newDateIsValid() {
    return moment(this.newDate, 'YYYY-MM-DD').isValid();
  }

  @computed('reportDate', 'dates.structures.[]')
  get timetableDay() {
    if (isEmpty(this.reportDate) || isEmpty(this.dates.structures)) {
      return;
    }
    return this.dates.dayForDate(this.reportDate);
  }

  @tracked groupId = null;

  get group() {
    if (isEmpty(this.groupId)) {
      return;
    }
    return this.model.groups.find((group) => group.id === this.groupId);
  }

  @computed('model.groups.[]')
  get sortedGroups() {
    return this.model.groups
      .filter((group) => {
        if (group.status === NSWStatus.INACTIVE) {
          return false;
        }
        // Include all other groups.
        return true;
      })
      .sort(
        (a, b) => a.type - b.type || (a.name || '').localeCompare(b.name || ''),
      );
  }

  @computed('reportDate', 'group.name')
  get title() {
    let date = moment(this.reportDate, 'YYYY-MM-DD').format(
      'dddd Do MMMM, YYYY',
    );
    let title = `Daily absences and lates for ${date}`;
    if (!isEmpty(this.group)) {
      title = `${this.group.name} - ${title}`;
    }

    return title;
  }

  @computed('model.{learners.[],records.[]}')
  get absentees() {
    let absentees = uniqBy(
      this.model.records.filter((record) => {
        return !isEmpty(record.code) && record.code !== 'P';
      }),
      'person_id',
    ).map((record) => {
      let contacts = record.get('person.learner.primaryContacts') ?? [];
      return {
        personId: record.person_id,
        person: record.person,
        firstContact: contacts[0],
        secondContact: contacts[1],
        records: [],
      };
    });

    this.model.records.forEach((record) => {
      let absentee = findBy(absentees, 'personId', record.person_id);
      if (isEmpty(absentee)) {
        return;
      }
      absentee.records.push(record);
    });

    return absentees;
  }

  @action
  setGroup(group) {
    if (isEmpty(group)) {
      this.groupId = null;
    } else {
      this.groupId = group.id;
    }
  }

  @action
  setDate() {
    if (this.newDateIsValid) {
      this.reportDate = this.newDate;
    }
  }
}
